import type { FunctionComponent } from 'react';

import { theme } from '../../theme';

export type ProficiencyScaleProps = {
    readonly active: boolean;
    readonly level?: number | null;
    readonly scaleCount: number;
};

export const ProficiencyScale: FunctionComponent<ProficiencyScaleProps> = ({ active, level = 0, scaleCount }) => {
    const fillColor = active ? theme.color.orange[800] : theme.color.gray[800];
    const barWidth = 4;
    const barSpacing = 4;
    const totalWidth = scaleCount * (barWidth + barSpacing) - barSpacing;

    return (
        <span data-testid={active ? 'is-active' : undefined}>
            {/** biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration */}
            <svg
                fill="none"
                height="12"
                viewBox={`0 0 ${totalWidth} 12`}
                width={totalWidth}
                xmlns="http://www.w3.org/2000/svg"
            >
                {Array.from({ length: scaleCount }).map((_, index) => (
                    <rect
                        // biome-ignore lint/suspicious/noArrayIndexKey: suppressed due to migration
                        key={index}
                        fill={index < (level ?? 0) ? fillColor : theme.color.gray[500]}
                        height="12"
                        width={barWidth}
                        x={index * 8}
                    />
                ))}
            </svg>
        </span>
    );
};
